export const APP_NAME="DictionDeck";
export const APP_HEADING="Let's learn English";
export const LOADING_STATE="Loading...";
export const WORD_NOT_FOUND_TRY_AGAIN="Word not found, try another word";
export const WORD_NOT_FOUND="Word not found,";
export const DID_YOU_MEAN="Did you mean?";
export const SEARCH_BUTTON="Search";
export const SEARCH_PLACEHOLDER="Type a word";
